import DataNotFound from '@/components/ui/not-found/data-not-found';
import ServerlessGPUPlaygroundBlueprintLLM from '@/features/blueprint/playground/llm';
import { TypeBlueprint } from '@/features/blueprint/type';
import ViewCredit from '@/pages/setting/payment/view-credit';
import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useGetServerlessProjectById } from '@/service/serverless-gpu/hook';
import { Link, useParams } from 'react-router-dom';
import { useGetUserBalance } from '@/service/payment/hook';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { fCurrencyUSDExtended } from '@/utils/formatNumber';
import { Button } from '@/components/ui/button';
import { useQuickTopup } from '@/hooks/useQuickTopup';
import { QuickTopupDialog } from '@/components/quick-topup/QuickTopupDialog';

const ServerlessGPUPlaygroundBlueprint = () => {
  const { orgId, projectId, workspaceId } = useParams<RouteParams>();
  const { data: dataProject } = useGetServerlessProjectById({
    project_id: projectId!,
  });
  const isBlueprint =
    dataProject?.project?.project_name?.includes('[Blueprint]');
  const typeBlueprint = dataProject?.project?.project_name
    ?.split('[')[2]
    ?.split(']')[0];

  // Credit balance check
  const { data: creditData, isLoading: isLoadingCredit } = useGetUserBalance();
  const totalAvailableCredit = creditData?.balance ?? 0;
  const hasInsufficientBalance = totalAvailableCredit < 0.5;
  const { isOpen, setIsOpen, openTopup, onSuccess } = useQuickTopup();

  const Render = () => {
    if (!isBlueprint) {
      return (
        <DataNotFound
          goBackHref={
            PATH_PAGE.dashboard.serverlessGPU.byId(orgId!, workspaceId!, projectId!)
              .playground
          }
        />
      );
    }

    if (typeBlueprint === TypeBlueprint.LLM) {
      return <ServerlessGPUPlaygroundBlueprintLLM />;
    } else {
      return <div></div>;
    }
  };

  return (
    <>
      {/* Insufficient Balance Warning */}
      {!isLoadingCredit && hasInsufficientBalance && (
        <div className="container mt-4">
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Insufficient Credit Balance</AlertTitle>
            <AlertDescription className="mt-2">
              <p>
                Your current balance is {fCurrencyUSDExtended(totalAvailableCredit)}.
                Please top up your account to use the playground.
              </p>
              <Button
                variant="outline"
                size="sm"
                className="mt-2"
                onClick={openTopup}
              >
                Quick Top-up $5
              </Button>
            </AlertDescription>
          </Alert>
        </div>
      )}
      <Render />
      <div className='container'>
        <div className="mt-8 border-t pt-8">
          <ViewCredit isShowPaymentLink={true} />
        </div>
      </div>

      <QuickTopupDialog open={isOpen} onOpenChange={setIsOpen} onSuccess={onSuccess} />
    </>
  );
};

export default ServerlessGPUPlaygroundBlueprint;
